import { Action } from 'redux';

import { LibraryApi } from 'global/api';
import { Subject, PathwayDetail } from 'labxchange-client';
import { LXThunkAction, LXThunkDispatch } from 'global/types';
export enum Types {
    FETCHING_SUBJECT_AREAS = 'FETCHING_SUBJECT_AREAS',
    FETCHED_SUBJECT_AREAS = 'FETCHED_SUBJECT_AREAS',
    LOAD_CURRENT_PATHWAY = 'LOAD_CURRENT_PATHWAY',
    CLOSE_CONGRATULATIONS_MODAL = 'CLOSE_CONGRATULATIONS_MODAL',
}

export interface FetchingSubjectTags extends Action {
    readonly type: Types.FETCHING_SUBJECT_AREAS;
}
export interface FetchedSubjectTags extends Action {
    readonly type: Types.FETCHED_SUBJECT_AREAS;
    readonly success: boolean;
    readonly subjectTags: Subject[];
}

export interface SetCurrentPathway extends Action {
    readonly type: Types.LOAD_CURRENT_PATHWAY;
    readonly id: string;
    readonly pathway: PathwayDetail;
}

export interface CloseCongratulationModal extends Action {
    readonly type: Types.CLOSE_CONGRATULATIONS_MODAL;
}

export type ActionTypes = FetchingSubjectTags|
    FetchedSubjectTags|
    SetCurrentPathway|
    CloseCongratulationModal;

export const fetchSubjectTags = (): LXThunkAction<void> => {
    return async (dispatch: LXThunkDispatch) => {
        dispatch({type: Types.FETCHING_SUBJECT_AREAS});
        try {
            const subjectTags = await LibraryApi.getSubjectTags();
            dispatch({
                type: Types.FETCHED_SUBJECT_AREAS,
                success: true,
                subjectTags,
            });
        } catch {
            dispatch({
                type: Types.FETCHED_SUBJECT_AREAS,
                success: false,
                subjectTags: [],
            });
        }
    };
};

export const setCurrentPathway = (id: string, pathway: PathwayDetail): LXThunkAction<void> => {
    return async (dispatch: LXThunkDispatch) => {
        dispatch({type: Types.LOAD_CURRENT_PATHWAY, id, pathway});
    };
};

export const closeCongratulationModal = (): LXThunkAction<void> => {
    return async(dispatch: LXThunkDispatch) => {
        dispatch({type: Types.CLOSE_CONGRATULATIONS_MODAL});
    };
};
